if (!customElements.get("product-delivery-estimate")) {
    customElements.define(
        "product-delivery-estimate",
        class ProductDeliveryEstimate extends HTMLElement {
            constructor() {
                super();
                this.handleVariantChange = this.handleVariantChange.bind(this);
            }

            connectedCallback() {
                this.dateElement = this.querySelector("[data-delivery-date]");
                this.updateDate();
                this.updateAvailability();
                document.addEventListener("change", this.handleVariantChange);
            }

            disconnectedCallback() {
                document.removeEventListener(
                    "change",
                    this.handleVariantChange
                );
            }

            handleVariantChange(event) {
                const picker = event.target?.closest?.(
                    "variant-radios, variant-selects"
                );

                if (picker && this.isOwnVariantPicker(picker)) {
                    window.requestAnimationFrame(() =>
                        this.updateAvailability(
                            this.getSelectedVariant(picker)
                        )
                    );
                    return;
                }

                if (
                    event.target?.name !== "id" ||
                    !this.isOwnVariantInput(event.target)
                )
                    return;

                window.requestAnimationFrame(() => this.updateAvailability());
            }

            updateDate() {
                if (!this.dateElement) return;

                const businessDays = parseInt(this.dataset.businessDays, 10);
                const estimateDate = this.addBusinessDays(
                    new Date(),
                    Number.isNaN(businessDays) ? 3 : businessDays
                );

                this.dateElement.textContent = `${estimateDate.getDate()}.${
                    estimateDate.getMonth() + 1
                }.`;
            }

            addBusinessDays(date, days) {
                const estimateDate = new Date(date);
                estimateDate.setHours(0, 0, 0, 0);

                let addedDays = 0;
                while (addedDays < days) {
                    estimateDate.setDate(estimateDate.getDate() + 1);
                    const weekday = estimateDate.getDay();
                    if (weekday !== 0 && weekday !== 6) addedDays += 1;
                }

                return estimateDate;
            }

            updateAvailability(selectedVariant) {
                const selectionWasResolved = arguments.length > 0;
                const variant = selectionWasResolved
                    ? selectedVariant
                    : this.getCurrentVariant();
                const available = variant
                    ? variant.available === true
                    : selectionWasResolved
                      ? false
                      : this.dataset.available === "true";
                const hideUnavailable =
                    this.dataset.hideUnavailable === "true";

                this.classList.toggle("is-unavailable", !available);
                this.hidden = hideUnavailable && !available;
            }

            getSelectedVariant(picker) {
                const groups = Array.from(
                    picker.querySelectorAll("[data-product-form]")
                );
                if (!groups.length) return null;

                const selectedOptions = groups.map((group) =>
                    group.querySelector("[type=radio]:checked, select")?.value
                );
                if (selectedOptions.some((option) => option === undefined))
                    return null;

                return (
                    this.getVariantData(picker).find((variant) =>
                        variant.options.every(
                            (option, index) =>
                                String(option) ===
                                String(selectedOptions[index])
                        )
                    ) || null
                );
            }

            getCurrentVariant() {
                const variantId = this.getCurrentVariantId();
                const variants = this.getVariantData();
                if (!variantId || !variants.length) return null;

                return variants.find(
                    (variant) => String(variant.id) === String(variantId)
                );
            }

            getCurrentVariantId() {
                const mainInput = document.querySelector(
                    `#product-form-${this.dataset.sectionId}-${this.dataset.productId} input[name="id"]`
                );
                const stickyInput = document.querySelector(
                    '#product-form-add-to-cart-sticky input[name="id"]'
                );

                return mainInput?.value || stickyInput?.value || "";
            }

            getVariantPicker() {
                return Array.from(
                    document.querySelectorAll(
                        "variant-radios, variant-selects"
                    )
                ).find((picker) => this.isOwnVariantPicker(picker));
            }

            isOwnVariantPicker(picker) {
                return (
                    picker.dataset.section === this.dataset.sectionId &&
                    picker.dataset.productId === this.dataset.productId
                );
            }

            isOwnVariantInput(input) {
                const formId = input.closest("form")?.id;
                return (
                    formId ===
                        `product-form-${this.dataset.sectionId}-${this.dataset.productId}` ||
                    formId === "product-form-add-to-cart-sticky"
                );
            }

            getVariantData(picker = this.getVariantPicker()) {
                const script = picker?.querySelector(
                    'script[type="application/json"]'
                );

                if (!script) return [];

                try {
                    return JSON.parse(script.textContent);
                } catch (error) {
                    console.error("Unable to parse product variant data", error);
                    return [];
                }
            }
        }
    );
}
